<template>
  <section class="padding-x mb-[-50vh] py-0 overflow-hidden">
    <div
      id="hero"
      class="sticky top-0 flex min-h-svh w-full items-end pb-[clamp(2.25rem,2.1786rem_+_0.3571vi,2.5rem)] pt-28 sm:pt-28 md:pt-32"
    >
      <div class="relative flex w-full flex-col items-center">
        <div class="w-full items-end overflow-visible sm:overflow-clip">
          <div class="flex w-full items-start gap-10 overflow-visible sm:overflow-hidden">
            <MyName />
            <Star id="star" class="hidden lg:block translate-x-0 md:heading-size" />
          </div>
        </div>

        <div class="lg:column-gap spacing-t grid w-full grid-cols-12">
          <div
            class="col-span-full flex flex-col items-start gap-14 sm:col-span-4"
          >
            <div class="overflow-hidden">
              <svg
                id="down-arrow"
                stroke="currentColor"
                fill="none"
                stroke-width="1.25"
                viewBox="6 6 12 12"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="hide-on-mobile m-0 size-4 -translate-x-full p-0 md:size-6"
                color="#8C8C73"
                style="color: #8c8c73"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line x1="7" y1="7" x2="17" y2="17"></line>
                <polyline points="17 7 17 17 7 17"></polyline>
              </svg>
            </div>

            <p class="sr-only">
              A freelance full-stack developer, cutting-edge technologies to
              deliver comprehensive solutions for your business.
            </p>
            <p
              v-html="whoAmI"
              id="whoAmI"
              class="who-am-i heading-5 w-full max-w-[30ch] overflow-clip leading-snug font-medium text-balance text-center sm:max-w-[37ch] sm:text-left lg:text-start"
            ></p>

            <div class="relative origin-left overflow-hidden sm:scale-150 -mt-4 sm:mt-6 w-full flex justify-center sm:block">
              <div id="resume-btn" class="w-full sm:w-auto">
                <a
                  href="https://drive.google.com/file/d/1fHKgXVwb-4VHEMEO9ea0DifJBe8EfbOg/view"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="border-flax-smoke-700 text-flax-smoke-700 hover:bg-flax-smoke-300 hover:text-flax-smoke-900 rounded-full border px-6 py-3 text-sm font-medium font-fancy transition-[background-color,color] duration-300 ease-in-out block w-fit mx-auto sm:mx-0"
                >
                  View My Resume
                </a>
              </div>
            </div>
          </div>

          <div
            id="profile-container"
            class="relative col-span-full sm:col-span-4 order-first sm:order-none mt-6 sm:mt-10 h-[40vh] sm:h-[20vh] max-w-lg flex-col rounded-lg select-none sm:mt-0 sm:h-full md:flex md:h-[50vh]"
          >
            <div class="overlay bg-flax-smoke-50 absolute inset-0 z-2"></div>
            <img
              id="profile-img"
              :src="profile"
              alt="Nhi Y. Ngo profile"
              class="size-full scale-90 rounded-lg object-cover object-top"
            />
          </div>

          <!-- content-end justify-self-end  -->
          <div
            class="relative col-span-8 size-full overflow-clip text-end sm:col-span-4"
          >
            <div
              id="available-for-work"
              class="absolute right-0 bottom-0 hidden sm:flex translate-y-full flex-col items-end"
            >
              <p
                class="3xl:text-base block leading-snug font-medium -tracking-tight uppercase"
              >
                Available for work
              </p>
              <h3
                class="3xl:heading-1 heading-1-alt font-fancy block leading-none font-bold -tracking-tight"
              >
                2026
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-[70vh] sm:h-[75vh] md:h-[70vh]"></div>
  </section>
</template>

<script setup lang="ts">
  import { onBeforeMount, ref } from 'vue';
  import { MyName, Star } from '../design';
  import { profile } from '@/assets/images';
  import { getAvailableForWorkDate, textSplitterIntoChar } from '@/functions';

  const whoAmI = ref(
    'AI & software developer building AI/ML systems, infrastructure, and perception for physical AI. Interested in autonomous systems, robotics, and AI/ML software.',
  );
  const AvailableForWorkDate = ref('');

  onBeforeMount(() => {
    whoAmI.value = textSplitterIntoChar(whoAmI.value);
    AvailableForWorkDate.value = getAvailableForWorkDate();
  });
</script>
